<template>
  <div class="modal fade in" ref="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">Privileges</h4>
        </div>
        <div class="modal-body">
          <form class="form-horizontal">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="problemDevices"
                v-model="problemDevices"
              >
              <label
                class="form-check-label"
                for="problemDevices"
              >Problem Devices</label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="appsUpdateLogs"
                v-model="updateLogs"
              >
              <label
                class="form-check-label"
                for="appsUpdateLogs"
              >Update Logs</label>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-info"
            v-on:click="handleSave"
          >Save</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
</template>
<script>
import api from "../../api";

const problemDevicesPrivilege = 1;
const updateLogsPrivilege = 2;

export default {
  name: "privilege-modal",
  data() {
    return {
      uid: "",
      privileges: []
    };
  },
  computed: {
    problemDevices: {
      get() {
        return this.privileges.includes(problemDevicesPrivilege);
      },
      set() {
        this._toggle(problemDevicesPrivilege);
      }
    },
    updateLogs: {
      get() {
        return this.privileges.includes(updateLogsPrivilege);
      },
      set() {
        this._toggle(updateLogsPrivilege);
      }
    }
  },
  methods: {
    _toggle(val) {
      const index = this.privileges.indexOf(val);
      if (index >= 0) {
        this.privileges.splice(index, 1);
      } else {
        this.privileges.push(val);
      }
    },
    async show(uid) {
      this.uid = uid;
      const res = await api.post({
        path: "/userprivileges/getbyuid",
        data: { appid: this.$route.query.appid, uid },
        withLoading: true
      });
      this.privileges = res.privileges;
      window.jQuery(this.$refs.modal).modal("show");
    },
    async handleSave() {
      const { privileges, uid } = this;
      await api.post({
        path: "/userprivileges/updatebyuid",
        data: {
          appid: this.$route.query.appid,
          uid,
          privileges
        },
        withLoading: true
      });
      window.jQuery(this.$refs.modal).modal("hide");
    }
  }
};
</script>



// WEBPACK FOOTER //
// PrivilegeModal.vue?4c145e95